import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["columns", "rows", "headerRows"];
import { useMemo } from 'react';
import { Table } from 'foundations-components/transitional/components/Table';
import ACSkeletonBox from './ACSkeletonBox';
import { ACTableRowNoInlineRadius } from '../table/SharedTableComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_CELL_WIDTH = 200;
const MIN_CELL_WIDTH = 80;
const TableCellSkeleton = () => {
  const width = useMemo(() => Math.floor(Math.random() * (MAX_CELL_WIDTH - MIN_CELL_WIDTH + 1) + MIN_CELL_WIDTH), []);
  return /*#__PURE__*/_jsx(ACSkeletonBox, {
    animated: true,
    "data-test-id": "table-skeleton-box",
    style: {
      width: `${width}px`,
      height: '16px'
    }
  });
};
const ACTableSkeleton = _ref => {
  let {
      columns,
      rows,
      headerRows = 1
    } = _ref,
    tableProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Table, Object.assign({
    "data-test-id": "table-skeleton-loader"
  }, tableProps, {
    children: [/*#__PURE__*/_jsx("thead", {
      children: Array.from({
        length: headerRows
      }).map((_, index) => {
        const cells = Array.from({
          length: columns
        }).map((__, i) => /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(TableCellSkeleton, {})
        }, i));
        return index > 0 ? /*#__PURE__*/_jsx(ACTableRowNoInlineRadius, {
          children: cells
        }, index) : /*#__PURE__*/_jsx("tr", {
          children: cells
        }, index);
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: Array.from({
        length: rows
      }).map((_, index) => /*#__PURE__*/_jsx("tr", {
        children: Array.from({
          length: columns
        }).map((__, i) => /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(TableCellSkeleton, {})
        }, i))
      }, index))
    })]
  }));
};
export default ACTableSkeleton;